export default "/images/3bc30dfb3ef0919d8ee53c7f08018005.avif";